import { createApp } from "vue";
import App from "./App.vue";
import "@/sass/index.sass";
import router from "./router";
import VueCookies from "vue-cookies";
import store from "./store";
import utils from "./utils";

import "vue-awesome-paginate/dist/style.css";
import VueAwesomePaginate from "vue-awesome-paginate";

import { quillEditor, Quill } from "vue3-quill";
import ImageUploader from "quill-image-uploader";
import ImageResize from "quill-image-resize";
import { uploadFile } from "./api/common";

Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/ImageResize", ImageResize);

const quillOptions = (type) => {
  return {
    placeholder: "",
    modules: {
      toolbar: {
        container: [
          [{ header: "1" }, { header: "2" }],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ color: [] }, { background: [] }],
          [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
          ["image"],
        ],
      },
      imageUploader: {
        upload: async (file) => {
          const formData = new FormData();
          function coverToWebp(file) {
            return new Promise((resolve, reject) => {
              const image = new Image();
              image.src = URL.createObjectURL(file);
              image.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(image, 0, 0, image.width, image.height);
                canvas.toBlob((blob) => {
                  const convertedFile = new File(
                    [blob],
                    file.name.replace(/\.[^.]+$/, ".webp"),
                    { type: "image/webp" }
                  );
                  resolve(convertedFile);
                }, "image/webp");
              };
              image.onerror = () => {
                reject(new Error("Failed to load image"));
              };
            });
          }
          try {
            formData.append("dir", type);
            if ((file.type !== "image/gif") & (file.type !== "image/webp")) {
              const newFile = await coverToWebp(file);
              formData.append("file", newFile);
            } else {
              formData.append("file", file);
            }
            const { data } = await uploadFile(formData);
            let url = data.url;
            return url;
          } catch (err) {
            console.log("Upload Failed:", err.message);
            return;
          }
        },
      },
      ImageResize: {
        parchment: Quill.import("parchment"),
      },
    },
  };
};

const app = createApp(App);
app.use(router);
app.use(store);
app.use(VueCookies);
app.use(VueAwesomePaginate);
app.use(quillEditor);

app.config.globalProperties.$utils = utils;
app.config.globalProperties.$quillOptions = quillOptions;
app.config.globalProperties.$typeCategory = {
  WISDOM_TEETH_EXTRACTION: "사랑니 발치",
  SLEEP_EXTRACTION: "수면 발치",
  JAW_SURGERY: "양악수술",
  CONTOUR_SURGERY: "윤곽수술",
  OTHER: "기타",
};

app.mount("#app");
